
import React, { useContext } from 'react';
import { propsContext } from '../dashboard';
import Barcode from 'react-barcode';
import '../../CSS/Invoice.css';
import AuthUser from '../AuthUser';
import moment from 'moment';

const Invoice = ({ specialDiscount, specialDiscountType, specialDiscountPercent, invoice, currentMember, isPreview = false }) => {
    const { user } = AuthUser();
    const { allSubTotalWithoutDiscount, cart, stickerCart, paidAmount } = useContext(propsContext);
    // const { currentMember } = useContext(memberContext);
    const today = new Date();
    const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    const currentMember2 = { ...currentMember };

    const billTotal = isNaN(parseInt(allSubTotalWithoutDiscount - specialDiscount)) ? 0 : parseInt(allSubTotalWithoutDiscount - specialDiscount);
    const safePaidAmount = isNaN(parseInt(paidAmount)) ? 0 : parseInt(paidAmount);
    const dueAmount = safePaidAmount < billTotal ? billTotal - safePaidAmount : 0;
    const returnAmt = safePaidAmount > billTotal ? safePaidAmount - billTotal : 0;

    return (
        <div style={{ paddingLeft: '35px', paddingRight: '35px' }} className='invoice-print'>
            <div className="invoice-pharmacy-details d-flex justify-content-center">
                <div className="text-center">
                    <h5>{user?.organization?.name}</h5>
                    <p>Location : {user?.organization?.address}</p>
                    <p>Tel : {user?.organization?.mobile}</p>
                    {/* <p>Vat Reg No :534565 </p> */}
                    <h6 className="mt-2">{isPreview ? 'PREVIEW CASH MEMO' : 'CASH MEMO'}</h6>
                </div>
            </div>
            <div className="invoice-date invoice-border-dashed">
                {
                    currentMember2?.member_name &&
                    <div>
                        <p>Member Name: {currentMember2?.member_name}</p>
                        <p>Phone Number: {currentMember2?.member_phone}</p>
                    </div>
                }

                <div className='d-flex justify-content-between'>
                    <div>
                        <p>Sales Person : {user?.name} </p>
                        <p>Date : {new Date().toLocaleDateString('en-GB')} </p>
                    </div>
                    <div>
                        <p style={{ textAlign: 'end' }}>Invoice No : {isPreview ? 'Preview inv' : invoice} </p>
                        <p style={{ textAlign: 'end' }}>Time : {moment(time, 'HH:mm:ss').format('hh:mm A')} </p>
                    </div>
                </div>
            </div>
            <div className="invoice-item-table">
                <table>
                    <tr className='invoice-border-dashed'>
                        <td width={'51%'}>Item</td>
                        <td width={'15%'} className='text-right'>Qty</td>
                        <td width={'20%'} className='text-right'>Price</td>
                        <td width={'15%'} className='text-right'>Total Price</td>
                    </tr>
                    {
                        stickerCart.filter(c => parseInt(c.pcs) > 0).map((item, i) =>
                            <tr key={i}>
                                <td width={"51%"} >{item.name}</td>
                                <td width={"15%"} className='text-start'>{item?.pcs}</td>
                                <td width={"20%"} className='text-start'>{parseInt(item?.price)}</td>
                                <td width={"15%"} className='text-end'>{parseInt(item.totalPrice)}</td>
                            </tr>)
                    }
                    <tr className='invoice-border-dashed-top'>
                        <td colSpan={3} className='text-end fw-bolder'>Sub Total : </td>
                        <td className='text-end'>{isNaN(parseInt(allSubTotalWithoutDiscount)) ? 0 : parseInt(allSubTotalWithoutDiscount)} </td>
                    </tr>

                    <tr>
                        <td colSpan={3} className='text-end'>VAT / TAX : </td>
                        <td className='text-end'>0</td>
                    </tr>
                    {
                        user.user_type === "cashier" &&
                        <tr>
                            <td colSpan={3} className='text-end'>
                                Special Discount{specialDiscountType === 'Percentage' && specialDiscountPercent ? ` (${specialDiscountPercent}%)` : ''} :
                            </td>
                            <td className='text-end'>{isNaN(parseFloat(specialDiscount)) ? '0.00' : parseFloat(specialDiscount).toFixed(2)}</td>
                        </tr>
                    }

                    <tr className='invoice-border-dashed-top'>
                        <td colSpan={3} className='text-end fw-bold'>Bill Total : </td>
                        <td className='text-end'>{billTotal} </td>
                    </tr>

                    {
                        user.user_type === "cashier"
                        &&
                        <tr>
                            <td colSpan={3} className='text-end'>Paid Amount : </td>
                            <td className='text-end'>{safePaidAmount} </td>
                        </tr>
                    }

                    {
                        user.user_type === "cashier" && dueAmount > 0 &&
                        <tr>
                            <td colSpan={3} className='text-end fw-bold' style={{ color: '#d33' }}>Due Amount : </td>
                            <td className='text-end fw-bold' style={{ color: '#d33' }}>{dueAmount} </td>
                        </tr>
                    }

                    {
                        user.user_type === "cashier" &&
                        <tr className='invoice-border-dashed'>
                            <td colSpan={3} className='text-end'>Return Amount : </td>
                            <td className='text-end'>{returnAmt} </td>
                        </tr>
                    }
                </table>
            </div>
            <div className=" invoice-creator mt-1">
                <p>Provided By: Cashier</p>
            </div>
            <div className='row mt-3'>
                <p className='border-bottom w-50 mt-2 fw-bold'>Terms & Condition:</p>
                <p>১. ক্যাশ মেমো ছাড়া ওষুধ ফেরত নেওয়া হয় না ।</p>
                <p >২. বিক্রিত ওষুধ ৭ দিন পর ফেরত নেওয়া হয় না ।</p>
                <p >৩. ইনসুলিন ও বিদেশী ওষুধ ফেরত নেওয়া হয় না ।</p>
                <p >৪. বিক্রিত ওষুধ এর টাকা ফেরত দেওয়া হয় না  ।</p>
                <p>৫. কাটা ছেড়া ও ফ্রিজের বিক্রিত ওষুধ ফেরত নেওয়া হয় না । </p>

            </div>
            <div className="branding-section mt-3 mx-auto text-center">
                <p>Software and services developed by MacroHealthPlus, your trusted technology partner.</p>
            </div>


            <div className="invoice-greeting d-flex justify-content-center align-items-center mt-1">
                <Barcode displayValue={false} height={40} width={3} value={invoice} />
            </div>
            <div className="d-flex justify-content-center branding-section">
                <p>Thank You</p>
            </div>
        </div>
    );
};

export default Invoice;